import React from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import DigitalWallet from "./components/DigitalWallet";
import ExclusiveLuxury from "./components/ExclusiveLuxury";
import BuyExclusiveGoods from "./components/BuyExclusiveGoods";
import Features from "./components/Features";
import BrandPartners from "./components/BrandPartners";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <BrandPartners />
      <ExclusiveLuxury />
      <BuyExclusiveGoods />
      <Features />
      <DigitalWallet />
      <Footer />
    </div>
  );
}

export default App;
